<template lang="pug">
  .report-table
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :hideImportBtn="true"
      :hideAddButton="true"
      :hideSearch="true"
      :showTotal="true"
      :showCol="false"
      :showViewPanel="false"
    )
    e-table(
      :items="itemsWithWidths"
      :showCheckbox="false"
      :showDeleteButton="false"
      :showEditButton="false"
      :actionColumnWidth="70"
    )
    router-view
</template>

<script>
import { report } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import customWidths from './customWidths'

const DEFAULT_COLUMN_WIDTH = 270

export default {
  name: 'report-table',
  mixins: [tableMixin],
  computed: {
    itemsWithWidths() {
      if (customWidths[this.$route.name]) {
        const prepared = {}
        const checkWidth = (elements, parent) => {
          elements.map((item) => {
            if (customWidths[this.$route.name][item.name]) {
              item.width = customWidths[this.$route.name][item.name]
            }
            if (parent && item.width) {
              parent.width = parent.width + (item.width - DEFAULT_COLUMN_WIDTH)
            }
            while (item.children && !prepared[item.label]) {
              prepared[item.label] = true
              item.width = DEFAULT_COLUMN_WIDTH * item.children.length
              checkWidth(item.children, item)
            }
          })
        }
        checkWidth(this.items._meta.fields)
      }
      return this.items
    },
  },
  methods: {
    getEndpoint(route) {
      return report.tables(route, route.meta.type)
    },
  },
}
</script>
